import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { convertPrice } from '~/utils'

// Dùng chung ở nhiều màn để hiện thị danh sách topping mà user đã chọn
const FoodItemTopping = ({ foodOptionTypes = [], color = 'text' }) => {
  if (!Array.isArray(foodOptionTypes) || foodOptionTypes.length <= 0) return null

  const renderValuesToppingType = (valuesTopping = []) => {
    return valuesTopping.map((itemTopping) => {
      const { id, quantity, name, price } = itemTopping
      return (
        <Box className="comma" marginRight="4px" key={id} display="flex" flexWrap="wrap">
          {quantity && (
            <Typography
              color={color}
              fontSize="1.4rem"
              component="div"
              whiteSpace="break-spaces">{`${quantity} x `}</Typography>
          )}

          <Typography color={color} fontSize="1.4rem">
            {name}
          </Typography>
          {!!price && (
            <Typography color={color} fontSize="1.4rem">
              (+ {convertPrice(price)})
            </Typography>
          )}
        </Box>
      )
    })
  }

  const renderContent = () => {
    return foodOptionTypes.map((topping) => {
      const { id, name, foodOptions } = topping

      return (
        <Box key={id} display="flex" flexWrap="wrap" alignItems="center">
          <Typography
            whiteSpace="break-spaces"
            component="h4"
            fontWeight="600"
            fontSize="1.4rem"
            color={color}>
            {name}:{' '}
          </Typography>
          <Typography display="flex" flexWrap="wrap" component="div" color={color}>
            {renderValuesToppingType(foodOptions)}
          </Typography>
        </Box>
      )
    })
  }

  return <Box>{renderContent()}</Box>
}

export default React.memo(FoodItemTopping)
FoodItemTopping.propTypes = {
  foodOptionTypes: PropTypes.array,
  color: PropTypes.string,
}
